import { Redirect, Route, Switch } from 'wouter';

import { DefaultRoute } from './Auth/DefaultRoute.tsx';
import { InitSupertokens } from './Auth/Logic/InitSupertokens.ts';
import { ResetPasswordRequest } from './Auth/ResetPassword/ResetPasswordRequest.tsx';
import { RefreshSession } from './Auth/RefreshSession.tsx';
import { LoginController } from './Auth/Login/LoginController.tsx';
import { Logout } from './Auth/Logout.tsx';
import { InitSentry } from './Utils/Sentry.ts';
import { MigracionController } from './Auth/Migracion/MigracionController.tsx';
import { CrearUsuarioController } from './Auth/CrearUsuario/CrearUsuarioController.tsx';
import { Env } from './Env.ts';
import { Checker } from './Auth/Checker.tsx';
import { Dashboard } from './Customer/Dashboard.tsx';
import { Perfil } from './Customer/Perfil.tsx';
import { Suspense } from 'react';
import { AdminPage } from './Admin/Admin/AdminPage.tsx';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';
import { Ingresando } from './Auth/Ingresando.tsx';
import { ResetPassword } from './Auth/ResetPassword/ResetPassword.tsx';
import 'dayjs/locale/es';

import './App.css';
import { Wrappers } from './Wrappers.tsx';
import { Pages } from './Pages.ts';
import * as z from 'zod';
import { es } from 'zod/locales';

if (import.meta.env.DEV) {
    // Adds messages only in a dev environment
    loadDevMessages();
}
//Cargo los mensajes de error en prod también, porque no anda bien el texto si no
loadErrorMessages();

InitSentry();

InitSupertokens();

z.config(es());

function App() {
    // eslint-disable-next-line no-console
    console.log(`Luker Console. Version: ${Env.PACKAGE_VERSION}`, {
        // SENTRY_DSN: Env.SENTRY_DSN,
        // VITE_CONFIG_CAT: Env.VITE_CONFIG_CAT,
        MODE: Env.MODE,
    });
    return (
        <Wrappers>
            <Switch>
                <Route
                    path={'/resetearpassword'}
                    component={ResetPasswordRequest}
                />
                {/*TODO: hacer un test case en auth que confirme que tiene la url bien para el email*/}
                <Route
                    path={'/resetearpasswordconfirm'}
                    component={() => {
                        const url = new URL(window.location.href);
                        // console.log(url.searchParams.toString());
                        if (!url.searchParams.get('token')) {
                            return <Redirect to={'/login'} />;
                        }
                        return <ResetPassword />;
                    }}
                />
                <Route
                    path={'/crearusuario'}
                    component={CrearUsuarioController}
                />
                <Route
                    path={'/refresh'}
                    component={RefreshSession}
                />
                <Route
                    path={'/migracion'}
                    component={MigracionController}
                />
                <Route
                    path={'/login'}
                    component={LoginController}
                />
                <Route
                    path={'/ingresando'}
                    component={Ingresando}
                />
                <Route
                    path={'/logout'}
                    component={Logout}
                />
                <Route
                    path={'/perfil'}
                    component={() => (
                        <Checker onlyUser>
                            <Perfil />
                        </Checker>
                    )}
                />
                <Route
                    path={'/facturacion'}
                    component={() => {
                        return (
                            <Suspense>
                                <Pages.Customer.TuCuenta />
                            </Suspense>
                        );
                    }}
                />
                <Route
                    path={'/facturacion/compra_exitosa'}
                    component={() => (
                        <Suspense>
                            <Pages.Customer.CompraExitosa />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/estadisticas'}
                    component={() => {
                        return (
                            <Suspense>
                                <Pages.Customer.Estadisticas />
                            </Suspense>
                        );
                    }}
                />
                <Route
                    path={'/configuracion'}
                    component={() => {
                        return (
                            <Suspense>
                                <Pages.Customer.Config />
                            </Suspense>
                        );
                    }}
                />
                <Route
                    path={'/contratar'}
                    component={() => {
                        return (
                            <Suspense>
                                <Pages.Customer.Contratar />
                            </Suspense>
                        );
                    }}
                />
                <Route
                    path={'/dashboard'}
                    component={() => (
                        <Checker onlyUser>
                            <Dashboard />
                        </Checker>
                    )}
                />
                <Route
                    path={'/admin/user_config/:cuenta_id'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.ConfigPageForAdmins />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/dashboard'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Dashboard />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/bloqueadas'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Bloqueadas />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/mails'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Mails />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/events'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Events />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/procesosdiarios'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.ProcesosDiarios />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cuentas'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Cuentas />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/suscripciones'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Suscripciones />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cobranzas/invoices'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Invoices />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/facturacion/facturas'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Facturas />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/facturacion/facturar'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Facturar />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/facturacion/planning'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.FacturacionPlanning />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/facturacion/tusfacturasapilog'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.TusFacturasApiLogPage />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/facturacion/tusfacturaswebhooks'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.TusFacturasWebhooksPage />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/contrataciones'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Contrataciones />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/usuarios'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Usuarios />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/planes'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Planes />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/planes/:id'}
                    component={(props) => (
                        <Suspense>
                            <Pages.Admin.Plan {...props} />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/trials'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Trials />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/migraciones'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Migraciones />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cobranzas'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Cobranzas />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/transferencias'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Transferencias />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cobranzas/dunning'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Dunning />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cobranzas/reportes_zenrise/:id?'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.ReportesZenrise />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cobranzas/reportes_desbloqueadas_sin_motivo'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.ReporteDesbloqueadasSinMotivoPage />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/auditlogs'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.AuditLogs />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/cobranzas/cuenta/:id'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Cuenta />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin/metrics'}
                    component={() => (
                        <Suspense>
                            <Pages.Admin.Metrics />
                        </Suspense>
                    )}
                />
                <Route
                    path={'/admin'}
                    component={() => <AdminPage />}
                />
                <Route component={DefaultRoute} />
            </Switch>
        </Wrappers>
    );
}

export default App;
